export default __webpack_public_path__ + "static/media/twod-bg.631b4f8e.svg";